import React from "react";
import { withNamespaces } from 'react-i18next';

const VidaAcademica = ({ t }) => {

  return (
    <>
      <div className="container">
        <div id="start" className="fantasmaAncora"></div>
        {/* AREA 1 VIDA ACADEMICA */}
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3" id="1">
            <h2>{t('moduleVidaAcademica:T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <p className="p_next">
              {t('moduleVidaAcademica:S.P1')}
            </p>
            <p className="p_next">
              {t('moduleVidaAcademica:S.P2')}
            </p>
            <p className="p_next">
              {t('moduleVidaAcademica:S.P3')}
            </p>
            <p className="p_next">
              {t('moduleVidaAcademica:S.P4')}
            </p>
            <iframe
              src="https://www.youtube.com/embed/SjDQmd8_Hzs"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="next"
              title={t('moduleVidaAcademica:S.Title.Title1')}
            ></iframe>
            <iframe
              src="https://www.youtube.com/embed/TearbSRap8M"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="next"
              title={t('moduleVidaAcademica:S.Title.Title2')}
            ></iframe>
            <iframe
              src="https://www.youtube.com/embed/OYlbgg-OBqs"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="next"
              title={t('moduleVidaAcademica:S.Title.Title3')}
            ></iframe>
            <iframe
              src="https://www.youtube.com/embed/Z2grGbSKR1E"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title={t('moduleVidaAcademica:S.Title.Title4')}
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (VidaAcademica);
